export default __webpack_public_path__ + "static/media/background4.2ca10db9.svg";